<template>
  <v-chip
    class="my-2"
    color="bg-gray-0"
    text-color="primary"
    @click="openMap"
  >
    <v-icon
      size="20"
      class="mr-2"
    >
      ui-icon-map-full
    </v-icon>
    <div class="text-button-small">
      {{ t('На карте', options) }}
    </div>
  </v-chip>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import I18NextVue from 'i18next'
import useCommonStore from 'www/vue_components/common/TheFilters/lpu/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))
const commonStore = useCommonStore()
const filtersStore = useFiltersStore()

const openMap = () => {
  window.open(getMapUrl(), '_blank')
}

function getMapUrl() {
  const query = []

  query.push(`town=${commonStore.town.translit}`)

  if (filtersStore.filters.doctorSpeciality) {
    query.push(`speciality=${filtersStore.filters.doctorSpeciality.translit}`)
  }

  if (filtersStore.filters.lpuType) {
    query.push(`lputype=${filtersStore.filters.lpuType.translit}`)
  }

  if (filtersStore.filters.place) {
    if (filtersStore.filters.place.isMetro) {
      query.push(`metro=${filtersStore.filters.place.translit}`)
    } else {
      query.push(`district=${filtersStore.filters.place.translit}`)
    }
  }

  if (query.length) {
    return `${commonStore.url.map}?${query.join('&')}`
  }

  return commonStore.url.map
}
</script>
